/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    session_id: number;
}
type IOutput = number[];

export const docReadSpeedStatusReset = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.DOC_READ_SPEED_STATUS_RESET, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});

export const docReadSpeedStatusResetAsync = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.DOC_READ_SPEED_STATUS_RESET, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
